/* global paysafe */

var bind = function (fn, me) {
  return function () {
    return fn.apply(me, arguments);
  };
};

function reportPaysafeError(config, contexte, codeErreur, message, details) {
  try {
    fetch("/ajax/paysafe-error.php", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        don_id: config.donId || 0,
        transaction_id: config.merchantRefNum || "",
        contexte: contexte,
        code_erreur: String(codeErreur || ""),
        message_erreur: String(message || ""),
        details: details || null,
      }),
    }).catch(function () {});
  } catch (e) {
    // Reporting silencieux — ne pas bloquer l'UX
  }
}

/* --------------------------------------------
  Initialization
  @Params: jQuery element
  @Returns: none
*/
var Paysafe = function ($element) {
  this.element = $element;
  this.reset = bind(this.reset, this);

  var config = window.OES_PAYSAFE || {};
  if (
    !config.checkoutApiKey ||
    !config.merchantRefNum ||
    !config.amount ||
    !config.donId
  ) {
    alert("Configuration de paiement incomplète.");
    return;
  }

  paysafe.checkout.setup(
    config.checkoutApiKey,
    {
      merchantRefNum: config.merchantRefNum,
      amount: config.amount,
      currency: config.currency || "CAD",
      environment: config.environment || "TEST",
      locale: "fr_CA",
      customer: {
        firstName: config.customer?.firstName || "N/A",
        lastName: config.customer?.lastName || "N/A",
        email: config.customer?.email || "N/A",
        phone: config.customer?.phone || "0000000000",
      },
      billingDetails: {
        street: config.billingDetails?.street || "N/A",
        city: config.billingDetails?.city || "N/A",
        state: config.billingDetails?.state || "N/A",
        country: config.billingDetails?.country || "CA",
        zip: config.billingDetails?.zip || "N/A",
      },
      displayPaymentMethods: ["card"],
      paymentMethodDetails: { card: { accountId: config.accountId || "" } },
    },
    function (instance, error, result) {
      const safeClose = () => {
        try {
          if (instance && typeof instance.close === "function") {
            instance.close();
          }
        } catch (closeErr) {
          console.warn("Impossible de fermer la popup Paysafe:", closeErr);
        }
      };

      if (error) {
        console.error("Paysafe API Error:", error);
        reportPaysafeError(
          config,
          "checkout",
          error.code || error.displayMessage,
          error.displayMessage || error.message,
          error,
        );
        safeClose();
        alert(
          "Une erreur est survenue pendant le paiement. Veuillez réessayer.",
        );
        return;
      }

      // Unexpected result (no token)
      if (!result || !result.paymentHandleToken) {
        console.error("Paysafe returned unexpected result:", result);
        reportPaysafeError(
          config,
          "sdk_init",
          "NO_TOKEN",
          "Paysafe n'a pas retourné de paymentHandleToken",
          result,
        );
        safeClose();
        alert("Le paiement n'a pas pu être initialisé correctement.");
        return;
      }

      if (result && result.paymentHandleToken) {
        const defaultPaymentErrorMessage =
          "Erreur lors de la creation du paiement.";

        fetch("/ajax/paysafe-payment.php", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            don_id: config.donId,
            transaction_id: config.merchantRefNum,
            payment_token: result.paymentHandleToken,
          }),
        })
          .then(async (r) => {
            const data = await r.json().catch(() => ({}));
            if (!r.ok || data.error) {
              throw data;
            }

            if (data.redirect_url) {
              window.location.href = data.redirect_url;
              return;
            }

            safeClose();
          })
          .catch((err) => {
            console.error("Payment creation error:" + err.message);

            if (err.redirect_url) {
              window.location.href = err.redirect_url;
              return;
            }

            safeClose();
            const shouldAppendMessage =
              !!err?.message && err.message !== defaultPaymentErrorMessage;
            const alertMessage = shouldAppendMessage
              ? defaultPaymentErrorMessage + ": " + err.message
              : defaultPaymentErrorMessage;

            alert(alertMessage);
          });
      } else {
        console.error("Paysafe returned unexpected result:", result);
      }
    },
  );
};

module.exports = Paysafe;
